import { useMutation, useQueryClient } from '@tanstack/react-query';
import createPrivateAdminPanelInstance from '../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../api/ApiRoutes';

const postToggleActiveLiveEvent = async ({ entityId, isActive }) => {
  const payload = {
    entity_type: 'LIVE',
    entity_id: entityId,
    is_active: isActive,
  };

  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const { data } = await PrivateAdminPanelInstance.post(
    API_ROUTES.SET_ENTITY_ACTIVE_STATUS,
    payload
  );
  return data;
};

export const useToggleActiveLiveEvent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['TOGGLE_ACTIVE_EVENT'],
    mutationFn: postToggleActiveLiveEvent,

    onMutate: async ({ entityId, isActive, sportId }) => {
      await queryClient.cancelQueries(['GET_LIVE_EVENT_ENTITIES', sportId]);

      const previous = queryClient.getQueryData([
        'GET_LIVE_EVENT_ENTITIES',
        sportId,
      ]);

      queryClient.setQueryData(['GET_LIVE_EVENT_ENTITIES', sportId], (old) => {
        if (!old) return old;
        return old.map((league) => ({
          ...league,
          events: league.events.map((ev) =>
            ev.entity_id === entityId ? { ...ev, is_active: isActive } : ev
          ),
        }));
      });

      return { previous, sportId };
    },

    onError: (_err, _vars, ctx) => {
      if (ctx?.previous) {
        queryClient.setQueryData(
          ['GET_LIVE_EVENT_ENTITIES', ctx.sportId],
          ctx.previous
        );
      }
    },

    onSettled: (_data, _err, variables) => {
      queryClient.invalidateQueries([
        'GET_LIVE_EVENT_ENTITIES',
        variables.sportId,
      ]);
    },
  });
};

